// extracted by mini-css-extract-plugin
export var more = "ArticleSidebar-module--more--76ac9";
export var sidebarImage = "ArticleSidebar-module--sidebarImage--e3d85";
export var sidebarItemCategory = "ArticleSidebar-module--sidebarItemCategory--55fb6";
export var sidebarItemContent = "ArticleSidebar-module--sidebarItemContent--b6810";
export var sidebarItemDate = "ArticleSidebar-module--sidebarItemDate--cc44a";
export var sidebarItemList = "ArticleSidebar-module--sidebarItemList--2b90d";
export var sidebarListItem = "ArticleSidebar-module--sidebarListItem--9cee0";